<template>
    <div class="consume">
        <el-container :style="{ height: number + 'px' }">
            <el-aside style="width:40%;border-right:1px solid #eee;">
                <!-- <el-input @keyup.enter.native="toFilterData" placeholder="请输入商品名称、别名关键字、按回车键搜索" v-model="input1"> -->
                <!-- <template slot="prepend">项目名称</template> -->
                <!-- </el-input> -->
                <h5>已购买项目信息</h5>
                <div ref="top">
                    <div class="el-card" v-for="(item,index) in tableList" :key="index">
                        <div class="el-card__header">
                            <div class="dis_flex flex_x_between flex_y_center">
                                <div><span>{{item.projectName}}</span> </div>
                                <!-- <button type="button" class="el-button el-button--text el-button--mini"><span>操作记录</span></button> -->
                                <div>
                                    <el-button type="danger" size="mini" @click="refundRow(item)"><span>退款</span></el-button>
                                    <el-button type="primary" size="mini" @click="editRow(item)"><span>划扣</span></el-button>
                                </div>
                            </div>
                        </div>
                        <div class="el-card__body" style="padding: 0px;">
                            <div class="border_bottom el-row">
                                <div class="border_right el-col el-col-8">
                                    <div class="goods-item"><span class="goods-lable">订购次数：</span><span>{{item.purchaseNumber}}</span>
                                        <!-- <span class="marlt_5">
                                            <div role="tooltip" id="el-popover-4103" aria-hidden="true" class="el-popover el-popper" tabindex="0" style="width: 240px; display: none;">
                                                <p>有效次数= 剩余数量-退款中数量-欠款占用的数量[欠款金额÷参考单价(向上取整)]</p>
                                            </div><span class="el-popover__reference-wrapper"><button type="button" class="el-button font_12 el-popover-botton-tip el-button--text el-popover__reference" aria-describedby="el-popover-4103" tabindex="0" style="color: rgb(220, 223, 230);">
                                                    <i class="el-icon-info"></i>
                                                </button></span>
                                        </span> -->
                                    </div>
                                </div>
                                <div class="el-col el-col-8">
                                    <div class="goods-item"><span class="goods-lable">价格：</span><span>{{item.projectAmt}}</span></div>
                                </div>
                                <div class="border_left el-col el-col-8">
                                    <div class="goods-item"><span class="goods-lable">剩余次数：</span><span>{{item.residueNumber}}</span></div>
                                </div>
                            </div>
                            <div class="border_bottom el-row">
                                <!-- <div class="border_right el-col el-col-8">
                                    <div class="goods-item"><span class="goods-lable">价格：</span><span>{{item.projectAmt}}</span></div>
                                </div> -->
                                <div class="el-col el-col-8">
                                    <div class="goods-item"><span class="goods-lable">项目补充：</span><span>{{item.projectReplenish}}</span></div>
                                </div>
                                <div class="border_left el-col el-col-8">
                                    <div class="goods-item"><span class="goods-lable">划扣补充：</span><span>{{item.musProjectReplenish}}</span></div>
                                </div>
                            </div>
                            <div class="el-row border_bottom">
                                <!-- <div class="border_right el-col el-col-8">
                                    <div class="goods-item"><span class="goods-lable">欠款金额：</span><span>¥ 0.00</span></div>
                                </div> -->
                                <div class="el-col el-col-16">
                                    <div class="goods-item"><span class="goods-lable">订购日期：</span><span>{{item.createTime}}</span></div>
                                </div>
                            </div>
                            <div class="el-row">
                                <div class="el-col el-col-24">
                                    <div class="goods-item"><span class="goods-lable color_red">备注信息：</span><span class="color_red">{{item.remark}}</span></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <el-pagination style="float:right;" @size-change="handleSizeChange1" @current-change="pageChanged1" :current-page="filters.pagination.page" :page-size="filters.pagination.limit" :page-sizes="[10, 20, 30, 50]" layout="total,prev, pager, next" :total="filters.pagination.total">
                    </el-pagination>
                </div>
            </el-aside>
            <el-container class="container">
                <el-main class="main_font">
                    <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
                        <el-tab-pane label="划扣项目" name="first">
                            <deduct :childData="childData" :refundData="refundData"></deduct>
                        </el-tab-pane>
                        <el-tab-pane label="退款项目" name="second">
                            <refund :refundData="refundData" :childData="childData"></refund>
                        </el-tab-pane>
                        <el-tab-pane label="注射信息" name="third">
                            <inject :childInject="childInject"></inject>
                        </el-tab-pane>
                    </el-tabs>
                </el-main>
                <el-footer class="el-footer">
                    <el-button type="warning" @click="buy" size="small">提交</el-button>
                </el-footer>
            </el-container>
        </el-container>
    </div>
</template>
<script>
import { mapState, mapGetters } from "vuex";
import { v4 as uuidv4 } from "uuid";
import { log } from 'util';
import deduct from './deduct'
import refund from './refund'
import inject from './inject'
export default {
    props: ['tableList', 'filters', 'userInfo', 'childData', 'refundData', 'childInject'],
    components: {
        deduct, refund, inject
    },
    data() {
        return {
            number: 0,
            input1: '',
            // childData: [],
            // refundData: [],
            // childInject: [],
            activeName: 'first',
        }
    },
    computed: {
        ...mapState([]),
        ...mapGetters(['productOptions',]),
    },
    created() {
        this.$nextTick(() => {
            this.number = document.documentElement.clientHeight - 150 - this.$parent.$refs.boxHeader.offsetHeight
        });
        setTimeout(() => {
            this.newData = this.$store.getters.productOptions;
            // console.log(this.newData);
        }, 1000);
    },
    methods: {
        handleClick() {

        },
        pageChanged1(page) {
            this.filters.pagination.page = page
            this.$parent.getProject(this.userInfo.ctmMobile, '', this.filters.pagination.page)
        },
        handleSizeChange1(sizes) {
            this.filters.pagination.limit = sizes
        },
        // //查询 
        toFilterData(val) { },
        editRow(row) {
            this.activeName = 'first'
            console.log(row);
            this.getConsumable(this.newData, row)
            this.judgments(this.refundData, this.childData, row)
            this.$forceUpdate()
        },
        // 封装划扣次数判断方法
        judgments(refundData, childData, row, ) {
            if (Number(row.residueNumber) != 0) {

                let newRefundData = refundData.map(v => {
                    return { ...v, musContent: v.refundContent, musAmt: v.refundAmt }
                })
                let newList = newRefundData.concat(childData);
                // console.log('newList');
                // console.log(newList);
                // 判断当前数组是否已经被划扣或退款
                let index = newList.findIndex(item => item.projectId === row.projectId)
                // 筛选出当前划扣和退款的数据中存在几条当前项目
                let res2 = newList.filter(ele => ele.projectId === row.projectId)
                // 已经滑扣过的次数总和
                let res = res2.reduce((sumData, key, index, arrData) => {
                    return sumData + key.musContent
                }, 0)
                // 已经划扣过的金额总和
                let res3 = res2.reduce((sumData, key, index, arrData) => {
                    return sumData + Number(key.musAmt)
                }, 0)
                if (index != -1) {
                    // console.log('该项目已经划扣或者退款过!!!!!!');
                    console.log(Number(res));
                    console.log(Number(row.residueNumber));
                    if (Number(res) < Number(row.residueNumber)) {
                        // console.log('划扣次数合理');
                        row.musAmt = ((row.projectAmt / row.purchaseNumber) * 1).toFixed(2)
                        if (Number(res) + 1 == row.residueNumber) {
                            // console.log('0000');
                            row.musAmt = (Number(row.projectAmt) - Number(row.amt) - res3).toFixed(2)
                        }
                        this.arrPush(childData, row, row.musAmt)
                    } else if (Number(res) >= Number(row.residueNumber)) {
                        _g.toast("warning", '有效次数不足！！！');
                        return;
                    }
                } else if (index == -1) {
                    console.log('暂时不存在该项目22222');
                    row.musAmt = ((row.projectAmt / row.purchaseNumber) * 1).toFixed(2)
                    this.arrPush(childData, row, row.musAmt)
                }
            } else if (Number(row.residueNumber) == 0) {
                _g.toast("warning", '该项目已经全部使用完,请重新购买!');
            }
        },
        // 封装push方法
        arrPush(childData, row, musAmt) {
            childData.push({
                amt: row.amt,
                createTime: row.createTime,
                deductNumber: row.deductNumber,
                id: row.id,
                isUpdate: row.isUpdate,
                musProjectReplenish: row.musProjectReplenish,
                projectAmt: row.projectAmt,
                projectId: row.projectId,
                musProjectId: row.projectId,//项目id
                musProjectName: row.projectName,
                musReplenish: row.projectReplenish,
                purchaseId: row.purchaseId,
                purchaseNumber: row.purchaseNumber,
                remark: row.remark,
                residueNumber: row.residueNumber,
                musContent: 1,//划扣次数默认为1
                unitPrice: row.projectAmt / row.purchaseNumber,//项目单价
                musAmt: musAmt,//当日划扣金额
                materialList: [],
                instruments: row.instruments,
                materList: row.consumables,
                consumables: row.consumables,
                maxNum: 2000,
            })
        },
        // 封装匹配项目下的耗材方法
        getConsumable(newData, row) {
            row.instruments = []
            row.consumables = []
            newData.forEach(item => {
                if (item.id == row.projectId) {
                    // 匹配项目下的仪器
                    row.arr = item.instrumentMenuList
                    row.arr.forEach(list => {
                        // console.log(this.userInfo.earId);
                        if (list.areaId.includes(this.userInfo.earId)) {
                            row.instruments.push(list)
                        }
                    });
                    if (row.instruments.length == 0) {
                        row.instruments.push({
                            instrumentName: '无',
                            id: 0,
                        })
                    }

                    // 匹配项目下的耗材
                    row.arr1 = item.consumableMenuList
                    row.arr1.forEach(list => {
                        if (list.areaId == undefined || list.areaId.includes(this.userInfo.earId)) {
                            row.consumables.push(list)
                        }
                    });
                }
            });

            // console.log('row.consumables');
            // console.log(row.consumables);
        },
        refundRow(row) {
            this.activeName = 'second'
            this.getList(this.refundData, this.childData, row)
            this.$forceUpdate()
            // console.log('this.refundData');
            // console.log(this.refundData);
        },
        refundDataArr(refundData, row, refundAmt) {
            refundData.push({
                amt: row.amt,
                projectAmt: row.projectAmt,
                id: row.id,//
                refundProjectId: row.projectId,//退款项目编号
                projectId: row.projectId,//退款项目编号
                refundProjectName: row.projectName,//退款项目名称
                unitPrice: row.projectAmt / row.purchaseNumber,//项目单价
                refundAmt: refundAmt,//退款金额
                refundContent: 1,//退款次数
                refundReplenish: row.projectReplenish,//退款补充
                refundCode: '',//退款卡号
                refundCodeTrue: '',//退款卡号是否真实 0、存在 1、不存在
                refundCount: '',//剩余次数
                remark: row.remark,//备注
                purchaseId: row.purchaseId,// 购买项目id
                residueNumber: row.residueNumber,
                maxNum: 2000,
            })
        },
        getList(refundData, childData, row) {
            if (Number(row.residueNumber) != 0) {
                let newRefundData = refundData.map(v => {
                    return { ...v, musContent: v.refundContent, musAmt: v.refundAmt }
                })
                let newList = newRefundData.concat(childData);
                // console.log('newList');
                // console.log(newList);
                // 判断当前数组是否已经被划扣或退款
                let index = newList.findIndex(item => item.projectId === row.projectId)
                // 筛选出当前划扣和退款的数据中存在几条当前项目
                let res2 = newList.filter(ele => ele.projectId === row.projectId)
                let res = res2.reduce((sumData, key, index, arrData) => {
                    return sumData + key.musContent
                }, 0)
                // 已经划扣过的金额总和
                let res3 = res2.reduce((sumData, key, index, arrData) => {
                    return sumData + Number(key.musAmt)
                }, 0)
                if (index != -1) {
                    console.log('该项目已经划扣或者退款过!!!!!!');
                    if (Number(res) < Number(row.residueNumber)) {
                        console.log('划扣次数合理');
                        row.refundAmt = ((row.projectAmt / row.purchaseNumber) * 1).toFixed(2)
                        console.log('row.purchaseNumber');
                        console.log(row.purchaseNumber);
                        console.log('row.projectAmt');
                        console.log(row.projectAmt);
                        console.log('row.refundAmt');
                        console.log(row.refundAmt);
                        if (Number(res) + 1 == row.residueNumber) {
                            row.refundAmt = (Number(row.projectAmt) - res3).toFixed(2)
                            // console.log('已经划扣的金额总和！！！');
                            // console.log(res3);
                            // console.log('最后一次划扣的金额！！！');
                            // console.log(row.musAmt);
                        }
                        this.refundDataArr(refundData, row, row.refundAmt)
                    } else if (Number(res) >= Number(row.residueNumber)) {
                        _g.toast("warning", '有效次数不足！！！');
                        return;
                    }
                } else if (index == -1) {
                    console.log('暂时不存在该项目22222');
                    row.refundAmt = ((row.projectAmt / row.purchaseNumber) * 1).toFixed(2)
                    console.log('row.purchaseNumber');
                    console.log(row.purchaseNumber);
                    console.log('row.projectAmt');
                    console.log(row.projectAmt);
                    console.log('row.refundAmt');
                    console.log(row.refundAmt);
                    this.refundDataArr(refundData, row, row.refundAmt)
                }
            } else if (Number(row.residueNumber) == 0) {
                _g.toast("warning", '该项目已经全部使用完,请重新购买!');
            }
        },

        buy() {
            // console.log(this.userInfo);
            if (this.userInfo.ctmCode == undefined) {
                this.userInfo.ctmCode = this.userInfo.cadCode
            }
            console.log(this.userInfo);
            this.userInfo.ctmDate = this.userInfo.sknDate
            this.childData.forEach(item => {
                item.instruments.forEach(ele => {
                    //   console.log(item.instrumentNo);
                    if (item.instrumentNo == ele.id) {
                        item.instrumentName = ele.instrumentName
                    }
                });
            });
            // console.log(this.childData);
            this.$parent.formValidate()
                .then(userInfo => {
                    let data = {
                        earId: this.userInfo.earId,//院区
                        earName: this.userInfo.earName,//院区名称
                        sknDate: this.userInfo.ctmDate,//日期
                        name: this.userInfo.ctmName,//顾客姓名
                        cadCode: this.userInfo.ctmCode,//客户卡号
                        caseCode: this.userInfo.caseCode,//病历号
                        status: this.userInfo.status,//分诊状态
                        sex: this.userInfo.ctmSex,//性别
                        age: this.userInfo.ctmAge,//年龄
                        mobile: this.userInfo.ctmMobile,//电话
                        empName: this.userInfo.ctmEmpName,//咨询师姓名
                        flag: this.userInfo.flag,//客户标签
                        sknFloor: this.userInfo.sknFloor,//楼层
                        informationSource: this.userInfo.sceName,//信息来源
                        createBy: Lockr.get("skinEmpId"),//创建人
                        information: this.userInfo.information,//是否宏脉数据
                        musInformationList: this.childData,//划扣信息
                        injectionProjectList: this.childInject,//注射项目
                        refundInformationList: this.refundData,//退款项目
                    }
                    // console.log('最后提交的总数据data');
                    // console.log(data);
                    api.requestQuiet("/skn/createSknMusInformation", data, (res) => {
                        if (res.result == true) {
                            this.$parent.delData()
                            this.activeName = 'first'
                            this.$parent.getProject(this.userInfo.ctmMobile, '', this.filters.pagination.page)
                            _g.toast("success", '项目处理成功！！！');
                        } else {
                            _g.toast("error", res.errMsg);
                        }
                    }, (err) => { });
                }).catch(err => {
                    _g.toast("warning", '请完善用户信息！！！');
                })
        },
    }
}
</script>
<style scoped>
.el-row {
  position: relative;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
.border_bottom {
  border-bottom: 1px solid #eee;
}

.font_12 {
  font-size: 12px !important;
}
.color_red {
  color: #fe2278 !important;
}
.name {
  margin-right: 10px;
}
.el-footer {
  border-top: 1px solid #eee;
  height: 30px !important;
  text-align: right;
  line-height: 30px;
}
.el-card {
  border-radius: 4px;
  border: 1px solid #ebeef5;
  background-color: #fff;
  overflow: hidden;
  color: #303133;
  -webkit-transition: 0.3s;
  transition: 0.3s;
}
.el-card__header {
  padding: 10px 20px;
  background-color: #f5f7fa;
}
.flex_y_center {
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}
.flex_x_between {
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
}
.dis_flex {
  display: -webkit-box !important;
  display: -ms-flexbox !important;
  display: flex !important;
}
.goods-item {
  line-height: 36px;
  font-size: 12px;
  margin-left: 20px;
  margin-right: 5px;
}
.border_right {
  border-right: 1px solid #eee !important;
}
.border_left {
  border-left: 1px solid #eee;
}
.el-button--mini {
  padding: 6px !important;
}
.doctor_col {
  display: flex;
}
.main_font {
  font-size: 13px;
  font-weight: 500;
  /* border: 1px solid blue; */
}
</style>


